import { useRecruitingInterview } from './hooks/useRecruitingInterview';
import CollectingData from '../../../containers/CollectingData';
import SubmitFailed from './containers/SubmitFailed';
import PreInterview from './components/PreInterview';
import InterviewEnd from './containers/InterviewEnd';
import { INTERVIEW_EXAM_ID } from './constants';
import ExamLayout from '../../../layouts/Exam';
import Interview from './containers/Interview';
import KYC from '../../../containers/KYC';

/** Walks the applicant through the steps of a recruiting interview. */
function RecruitingInterview() {
    const {
        jobId,
        phase,
        action,
        userId,
        detail,
        profile,
        counter,
        question,
        exitExam,
        webcamRef,
        isLoading,
        retrySubmit,
        nextQuestion,
        onKYCSuccess,
        onEnableMedia,
        startInterview,
        uploadProgress,
        mediaPermission,
    } = useRecruitingInterview();

    return (
        <ExamLayout headerTitle='Recruiting Interview'>
            {phase === 'KYC' && <KYC
                userId={userId}
                profile={profile}
                jobId={jobId || null}
                examId={INTERVIEW_EXAM_ID}
                examType='recruitingInterview'
                onSuccess={onKYCSuccess}
            />}

            {phase === 'PreInterview' && <PreInterview
                detail={detail}
                action={action}
                loading={isLoading}
                onStart={startInterview}
                onEnableMedia={onEnableMedia}
                mediaPermission={mediaPermission}
            />}

            {phase === 'Interview' && <Interview
                counter={counter}
                question={question}
                onExit={exitExam}
                loading={isLoading}
                webcamRef={webcamRef}
                onNext={nextQuestion}
            />}

            {phase === 'CollectingData' && <CollectingData
                progress={uploadProgress}
                description='Please remain on this page while we collect your interview data.'
            />}

            {phase === 'SubmitFailed' && <SubmitFailed
                loading={isLoading}
                onRetry={retrySubmit}
            />}

            {phase === 'InterviewEnd' && <InterviewEnd />}
        </ExamLayout>
    )
};

export default RecruitingInterview;
